import { Link } from 'react-router-dom';
import { Building2, LayoutDashboard, Smartphone, Flame, ArrowUpRight } from 'lucide-react';
import { useLang } from '../../contexts/LanguageContext';

const ICONS = [Building2, LayoutDashboard, Smartphone, Flame];

// "Who is who" strip — kills the Kaizen Kanri / Kanriva / FlowCrew /
// BBMI-OAI confusion in one pass, right under the hero.
export const BrandMapSection = () => {
  const { t } = useLang('brandmap');

  return (
    <section id="who-is-who" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-[#0b1220] border-y border-white/5">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-3xl mb-10">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00CED1]">{t.eyebrow}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-white">{t.title}</h2>
          <p className="mt-4 text-base text-white/55 leading-relaxed">{t.lead}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="brandmap-grid">
          {(t.items || []).map((item, i) => {
            const Icon = ICONS[i] || Building2;
            const isSeparate = Boolean(item.href);
            return (
              <div
                key={item.name}
                className={`relative p-6 rounded-2xl border transition-colors ${
                  isSeparate
                    ? 'border-dashed border-white/15 bg-white/[0.01] hover:border-white/30'
                    : 'border-white/10 bg-white/[0.03] hover:border-[#00CED1]/35'
                }`}
                data-testid={`brandmap-item-${i}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${isSeparate ? 'bg-white/5' : 'bg-[#00CED1]/10'}`}>
                    <Icon className={`h-4 w-4 ${isSeparate ? 'text-white/50' : 'text-[#00CED1]'}`} />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.14em] text-white/35 leading-tight">{item.tag}</span>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.name}</h3>
                <p className="text-sm text-white/50 leading-relaxed">{item.sub}</p>
                {isSeparate && (
                  <Link
                    to={item.href}
                    className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-[#00CED1] hover:gap-2 transition-all"
                    data-testid="brandmap-bbmi-link"
                  >
                    {item.linkLabel} <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BrandMapSection;
